/** Checks if the top of an element is above the top of a container */
export function isTopOfElementAboveContainer(element: HTMLElement, container: HTMLElement) {
    const { top: elementTop, bottom: elementBottom } = element.getBoundingClientRect();
    const { top: containerTop, bottom: containerBottom } = container.getBoundingClientRect();
    if (elementBottom > containerTop && elementTop < containerBottom && elementTop < containerTop) {
        return true;
    }
    return false;
}

/**
 * Omits the provided query parameter from the provided route
 * alias: omitQueryParam, removeQuerystring, omitQueryString
 */
export function removeQueryParam(route: string, removeKey: string) {
    const [beforeQuery, querySection] = route.split("?");
    if (querySection === undefined) {
        return route;
    }
    const splitPairs = querySection.split("&");
    const omitPairs = splitPairs.filter((pair) => {
        const [key] = pair.split("=");
        return key !== removeKey;
    });

    return `${beforeQuery}?${omitPairs.join("&")}`;
}

/**
 * Checks if an element has a parent with a specific class.
 *
 * @param {HTMLElement} element - The element to start the search from.
 * @param {string} className - The class name to search for.
 * @returns {boolean} Returns true if a parent element with the specified class is found, otherwise false.
 */
export function hasParentOfClass(element: HTMLElement, className: string) {
    let parent = element.parentElement;
    while (parent) {
        if (parent.className.includes(className)) {
            return true;
        }
        parent = parent.parentElement;
    }
    return false;
}
